import { platformClient } from "@/lib/musicApi";
import { getViewerKey } from "@/lib/viewerKey";

// A view = 10s of real playback (half the video when it is under 20s). Only small forward
// steps of currentTime count, so seeking, scrubbing and scroll-pasts never add up to a view.
// Fires at most once per tracker; the server dedupes per viewer per video per 6 hours.
export function makeViewTracker(videoId) {
  let last = null;
  let played = 0;
  let sent = false;
  return (ct, d) => {
    if (sent || !videoId) return;
    if (last !== null) {
      const dt = ct - last;
      if (dt > 0 && dt <= 1.5) played += dt;
    }
    last = ct;
    const need = d > 0 && d < 20 ? d / 2 : 10;
    if (played >= need) {
      sent = true;
      platformClient.post(`/watch/${videoId}/view`, { vk: getViewerKey() }).catch(() => {});
    }
  };
}
